export interface Customer {
  id: string;
  number: string;
  organisation: string;
  name: string;
  address_street: string;
  address_house_number: number;
  address_zipcode: string;
  address_city: string;
  address_country: string;
}

/** Weergavenaam contactpersoon: ContactPerson_FriendlyName uit AFAS, anders samengestelde naam. */
export function afasContactDisplayName(
  customer:
    | Pick<
        CustomerDetails,
        | 'contact_friendly_name'
        | 'contactperson_first_name'
        | 'contactperson_middle_name'
        | 'contactperson_last_name'
        | 'name'
        | 'organisation'
      >
    | null
    | undefined
): string {
  if (!customer) {
    return '—';
  }

  const friendly = customer.contact_friendly_name?.trim();
  if (friendly) {
    return friendly;
  }

  const fromPerson = [
    customer.contactperson_first_name,
    customer.contactperson_middle_name,
    customer.contactperson_last_name,
  ]
    .filter((part) => part != null && String(part).trim() !== '')
    .join(' ')
    .trim();

  if (fromPerson) {
    return fromPerson;
  }

  const fallback = customer.name?.trim() || customer.organisation?.trim();
  return fallback || '—';
}

export interface CustomerDetails {
  id: string;
  number: string;
  organisation: string;
  name: string;
  address_street: string;
  address_house_number: number;
  address_zipcode: string;
  address_city: string;
  updated_at: string;
  contact_friendly_name: string;
  contactperson_first_name: string;
  contactperson_middle_name: string | null;
  contactperson_last_name: string;
  contactperson_phone: string;
  contactperson_email: string;
  wmo_referentie: string;
  gemeente: string;
  gemeente_code: string;
  aanbesteding: string | null;
  aanbesteding_code: string | null;
}
